import { render } from "./ActivitatsView.vue?vue&type=template&id=618f3d22"
import script from "./ActivitatsView.vue?vue&type=script&lang=js"
export * from "./ActivitatsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__